import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {type IModalTomorrowGameController} from "views/components/modals/modal_tomorrow_game/modal_tomorrow_game.controller";
import {Modal, IconButton, Button} from "@mui/material";
import {ModalCloseBlock, ModalContent} from "views/components/modals/common";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";
import {InfoRounded} from "@mui/icons-material";

const SModalContent = styled(ModalContent)`
	overflow: hidden;
	border-radius: 20px;
	background: #5800c4;
	gap: 16px;
	padding: 16px 16px 32px;
	color: #fff;
	max-width: 350px;

	svg {
		width: 60px;
		height: 60px;
	}
`;

const Title = styled.div`
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
`;

const Description = styled.div`
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%;
`;

export const ModalTomorrowGame: React.FC = observer(() => {
	const {isOpen, close, i18n} = useViewController<IModalTomorrowGameController>(
		Bindings.ModalTomorrowGameController
	);

	return (
		<Modal open={isOpen}>
			<SModalContent>
				<ModalCloseBlock>
					<IconButton sx={{minWidth: 0}} onClick={close}>
						<CloseIcon color={"inherit"} />
					</IconButton>
				</ModalCloseBlock>
				<InfoRounded />

				<Title>{i18n.t("modal.tomorrow_game.title", "Spin for tomorrow’s roster")}</Title>

				<Description>
					{i18n.t(
						"modal.tomorrow_game.description",
						`All rosters are projected. If a selected player does not play in that day's contest, they will be replaced with a player of like or equal value`
					)}
				</Description>

				<Button variant="contained" color="secondary" onClick={close}>
					{i18n.t("modal.tomorrow_game.button", "Continue")}
				</Button>
			</SModalContent>
		</Modal>
	);
});
